const main = (): string => 'Hello!'

export default main
